module.exports = __webpack_public_path__ + "img/094-south-korea.20b8f8f1.svg";